"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var storefront_service_1 = require("../../services/storefront.service");
var common_helper_1 = require("../../helpers/common.helper");
var cart_service_1 = require("../../services/cart.service");
var Coupons = /** @class */ (function () {
    function Coupons(cart) {
        this.selectors = {
            applyCouponBtnSelector: '[data-trekkie-id="apply_discount_button"], .order-summary__section.order-summary__section--discount button[type="submit"], .section--reductions.hidden-on-desktop button[type="submit"]',
            couponCodeInputSelector: '#checkout_reduction_code',
            couponCodeMobileInputSelector: '#checkout_reduction_code_mobile',
            continueBtn: '#continue_button',
        };
        this.storefrontService = new storefront_service_1["default"]();
        this.cartService = new cart_service_1["default"]();
        this.currentCoupon = null;
        this.cart = cart;
        this.init();
    }
    Coupons.prototype.init = function () {
        this.bindEvents();
    };
    ;
    Coupons.prototype.bindEvents = function () {
        var _this = this;
        var $body = $('body');
        $body.on('click', this.selectors.applyCouponBtnSelector, function (e) { return __awaiter(_this, void 0, void 0, function () {
            var $btn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        $btn = $(e.target).closest('button');
                        if (!!$btn.hasClass('tag__button')) return [3 /*break*/, 2];
                        $(this.selectors.continueBtn).prop('disabled', true);
                        e.preventDefault();
                        return [4 /*yield*/, this.onAddCouponClickEvent()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    Coupons.prototype.onAddCouponClickEvent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var code, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        code = $(this.selectors.couponCodeInputSelector).val();
                        if (!code) {
                            code = $(this.selectors.couponCodeMobileInputSelector).val();
                            if (!code) {
                                return [2 /*return*/, alert('Code can not be empty')];
                            }
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.applyCustomCoupon(code)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.applyShopifyCoupon(code)];
                    case 3:
                        _a.sent();
                        window.location.reload();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Coupons.prototype.applyShopifyCoupon = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var isCouponApplied, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        isCouponApplied = this.isShopifyCouponAlreadyApplied(code);
                        if (isCouponApplied) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, fetch('/checkout?discount=' + code)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        err_2 = _a.sent();
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Coupons.prototype.isUpdateRequired = function () {
        return __awaiter(this, void 0, void 0, function () {
            var shopifyCouponApplied, isCustomCouponApplied, response, coupon, isMinCartAmountValid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shopifyCouponApplied = this.getShopifyCouponApplied();
                        if (!shopifyCouponApplied) {
                            return [2 /*return*/, false];
                        }
                        isCustomCouponApplied = this.isCustomCouponAlreadyApplied(shopifyCouponApplied);
                        if (isCustomCouponApplied) {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.storefrontService.get("custom-coupon/code/" + shopifyCouponApplied)];
                    case 1:
                        response = _a.sent();
                        coupon = response.data;
                        if (!coupon) {
                            return [2 /*return*/, false];
                        }
                        if (!coupon.options.productId) {
                            return [2 /*return*/, false];
                        }
                        isMinCartAmountValid = this.isMinCartAmountValid(coupon);
                        if (!isMinCartAmountValid) {
                            return [2 /*return*/, false];
                        }
                        this.currentCoupon = coupon;
                        return [2 /*return*/, true];
                }
            });
        });
    };
    Coupons.prototype.applyCustomCoupon = function (code) {
        return __awaiter(this, void 0, void 0, function () {
            var isCouponApplied, response, coupon, isMinCartAmountValid, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        isCouponApplied = this.isCustomCouponAlreadyApplied(code);
                        if (isCouponApplied) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.storefrontService.get("custom-coupon/code/" + code)];
                    case 1:
                        response = _a.sent();
                        coupon = response.data;
                        if (!coupon) {
                            return [2 /*return*/];
                        }
                        isMinCartAmountValid = this.isMinCartAmountValid(coupon);
                        if (!isMinCartAmountValid) {
                            alert('Minimum cart amount to apply free product is $' + coupon.options.minCartAmount);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.addCustomCoupon(coupon)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                    case 3:
                        err_3 = _a.sent();
                        console.log(err_3);
                        return [2 /*return*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Coupons.prototype.addCustomCoupon = function (coupon) {
        return __awaiter(this, void 0, void 0, function () {
            var err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.cartService.set(this.cart);
                        return [4 /*yield*/, this.cartService.update([coupon.options.variantId], [coupon.options.variantId], null, coupon)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_4 = _a.sent();
                        console.log(err_4);
                        alert('Something went wrong');
                        window.location.reload();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Coupons.prototype.isShopifyCouponAlreadyApplied = function (code) {
        var discountCodeEl = $('.tags-list span.reduction-code__text');
        if (!discountCodeEl) {
            return false;
        }
        if (!discountCodeEl.length) {
            return false;
        }
        return code.toLowerCase() === discountCodeEl.text().toLowerCase();
    };
    Coupons.prototype.getShopifyCouponApplied = function () {
        var discountCodeEl = $('.tags-list span.reduction-code__text:first');
        if (!discountCodeEl) {
            return false;
        }
        if (!discountCodeEl.length) {
            return false;
        }
        return discountCodeEl.text().toLowerCase();
    };
    Coupons.prototype.isCustomCouponAlreadyApplied = function (code) {
        for (var _i = 0, _a = this.cart.items; _i < _a.length; _i++) {
            var cartItem = _a[_i];
            if (!cartItem.properties) {
                continue;
            }
            var itemProperties = cartItem.properties;
            //@ts-ignore
            if (!itemProperties._custom_coupon) {
                continue;
            }
            //@ts-ignore
            if (itemProperties._custom_coupon.code === code) {
                return true;
            }
        }
        return false;
    };
    Coupons.prototype.isMinCartAmountValid = function (coupon) {
        var couponOptions = coupon.options;
        if (!couponOptions) {
            return true;
        }
        if (!couponOptions.minCartAmount) {
            return true;
        }
        if (!couponOptions.isMinCartAmountRequired) {
            return true;
        }
        var cartAmount = common_helper_1.getCartTotal(this.cart);
        var minCartAmount = parseFloat(coupon.options.minCartAmount);
        return minCartAmount <= cartAmount;
    };
    return Coupons;
}());
exports["default"] = Coupons;
